import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, YearlySummaryRow } from "../stores/store_types"

const callYearlySummariesAPI = (headers: AuthHeaders, parameter: { corporationId: number, startDate: Date, endDate: Date }, successCallback: (headers: AxiosResponseHeaders, yearly_summary_rows: Array<YearlySummaryRow>) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/yearly_summaries.json",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        start_date: parameter.startDate,
        end_date: parameter.endDate
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callDownloadYearlySummaryAPI = (headers: AuthHeaders, parameter: { corporationId: number, startDate: Date, endDate: Date }, successCallback: (headers: AxiosResponseHeaders, blob: Blob) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/yearly_summaries.csv",
    {
      headers: headers,
      responseType: "blob",
      params: {
        corporation_id: parameter.corporationId,
        start_date: parameter.startDate,
        end_date: parameter.endDate
      }
    }
  ).then((response: AxiosResponse) => {
    const mineType = response.headers["content-type"]
    const blob = new Blob([response.data], { type: mineType })
    successCallback(response.headers, blob)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { callYearlySummariesAPI, callDownloadYearlySummaryAPI }
